export default {
  clientAndPartners: {
    metatag: {
      title: 'SIS Innov & Tech - Clientes e Parceiros',
      description: 'Conheça os clientes e parceiros SIS Innov & Tech',
    },
  },
}
